export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.admin.staff': '员工管理',
  'menu.admin.shift-assignment': '班次分配',
  'menu.user.login': '登录',
  'menu.user.register': '注册',
  'menu.admin.user-management': '用户管理',
  'menu.admin.site-management': '物業管理',
  'menu.admin.site-details': '物業详情',
  'menu.admin.incident-management': '事件管理',
  'menu.admin.staff-management': '员工管理',
  'menu.admin.shift-management': '班次管理',
  'menu.admin.staff-leave-management': '员工请假管理',
  'menu.admin.shift-details': '班次详情',
  'menu.admin.staff-assignments': '员工分配',
  'menu.admin.attendance-management': '考勤管理',
  'menu.admin.site-document-management': '物业文件管理',

  'menu.mcp': 'MCP',
  'menu.mcp.flow-builder': 'MCP流程构建',
  'menu.mcp.mcp.flow-builder': 'MCP流程构建',
  'menu.logistics.admin.logistics-hub-management': '物流中心管理',
  'menu.admin.courier-management': '快递员管理',
  'menu.admin.driver-management': '司机管理',
  'menu.admin.vehicle-management': '车辆管理',
  'menu.admin.container-management': '集装箱管理',
  'menu.admin.parcel-management': '包裹管理',
  'menu.admin.asset-management': '资产管理',
  'menu.admin.tenant-management': '住戶管理',
  'menu.admin.public-holiday-management': '公共假期管理',
  'menu.admin.version-management': '版本管理',
};
